import Split from 'react-split';
import { ReactNode, useCallback, useState } from 'react';

type ColumnSplitterProps = {
  valid?: boolean
  initialSizes?: number[]
  minSize?: number
  onDragEnd?: (sizes: number[]) => void
  children: ReactNode
}
export const ColumnSplitter = ({
  valid,
  initialSizes,
  minSize,
  onDragEnd,
  children
}: ColumnSplitterProps) => {
  const [sizes, setSizes] = useState(initialSizes || [33, 67])
  const onDragEndCore = useCallback(
    (changedSizes: number[]) => {
      setSizes(changedSizes)
      if (onDragEnd) onDragEnd(changedSizes)
    },
    [setSizes, onDragEnd]
  )
  const gutterStyle = useCallback(
    () => {
      if (valid === false) return { display: 'none', width: '0px' }
      return {
        width: '10px',
        background: 'white',
        boxShadow: 'rgba(0, 0, 0, 0.3) -4px 0 4px -2px inset, rgba(0, 0, 0, 0.2) 3px 0 2px -3px inset',
        boxSizing: 'border-box'
      }
    },
    [valid]
  )
  return (
    <Split
      style={{
        display: 'flex',
        height: '100%',
        maxHeight: '100%',
        flexGrow: 1,
        overflow: 'hidden',
        boxSizing: 'border-box'
      }}
      direction="horizontal"
      expandToMin={true}

      sizes={valid === false ? [100, 0] : sizes}
      minSize={valid === false ? 0 : (minSize || 100)}
      gutterSize={valid === false ? 0 : undefined}
      onDragEnd={onDragEndCore}
      gutterStyle={gutterStyle}
    >
      {children}
    </Split>
  )
}